export const environment = {
    apiURL: 'https://doctorium-backend.web42.it/api/bff',
    recaptchaSiteKey: '6LerV50qAAAAAEK2MVz75bi_tcM5yPhzOvXtKFOp',
    websiteUrl: 'https://doctorium.web42.it',
    idleTimeout: 20,
    paypalClientID: 'ATrXfk61HMyoA1MhjME9RQjLUoBAkW3HVaXEjlyP9XWcfgT3k4DR4YhSYFFlQwNS2JrjHes2Sdp8BRdu',
    stripeKey: 'pk_test_51I1WEtG9cZO1vXPath3lfIhvoOpXiKcaZJlt7tKDMQLauhQogk2JwxThm036GaG1exoS9ZWcKSlpKpmFPgV71oeu00buLirJ1N',
    gtag: '',
    production: false,
};
